export default {
  namespaced: true,
  state: {
    servidor: null,
    saldoBancoHoras: [],
    lancamentosBancoHoras: [],
  },
  getters: {
    getServidor(state) {
      return state.servidor;
    },
    getSaldoBancoHoras(state) {
      return state.saldoBancoHoras;
    },
    getLancamentosBancoHoras(state) {
      return state.lancamentosBancoHoras;
    },
  },
  mutations: {
    setServidor(state, payload) {
      state.servidor = payload;
    },
    setSaldoBancoHoras(state, payload) {
      state.saldoBancoHoras = payload;
    },
    setLancamentosBancoHoras(state, payload) {
      state.lancamentosBancoHoras = payload;
    },
  },
  actions: {},
};
